export const partnersSubMenu = [
  {
    id: 3,
    link: "#partner",
    label: "Partner",
  },
  {
    id: 1,
    link: "#workforce",
    label: "Workforce",
  },
  {
    id: 2,
    link: "#customers",
    label: "Customers",
  },
  {
    id: 4,
    link: "#investors",
    label: "Investors",
  },
  {
    id: 5,
    link: "#community",
    label: "Community",
  },
  {
    id: 6,
    link: "#environment",
    label: "Environment",
  },
];
